import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { environment } from '../environments/environment';
import { GlobalStateService } from './services/state.service';
import { InicializerService } from './services/inicializer.service';
import { ModalService } from './shared/modal/service/modal.service';
import { AuthService } from './services/auth.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppComponent implements OnInit {

  form!: FormGroup
  loginTest = signal(false);
  inMaintenance = signal(environment.inMaintenance)
  inProduction = signal(environment.production)
  showLogin = true;
  
  private readonly fb = inject(FormBuilder)
  private readonly globalStateService = inject(GlobalStateService)
  private readonly inicializerService = inject(InicializerService)
  private readonly authService = inject(AuthService)

  constructor(
    public modal: ModalService
  ) { }
  ngOnInit(): void {
    this.inicializerService.inicializeOffices()
    this.form = this.fb.group({
      pass: ['']
    })
    !this.inMaintenance();
    this.globalStateService.setLoginTest(!environment.production);
    this.globalStateService.loginTest$.subscribe(data => {
      this.loginTest.set(data)
    });
  }

  verified() {
    const { pass } = this.form.value
    if (pass === 'certificados') this.showLogin = false
  }

}
